// extracted by mini-css-extract-plugin
module.exports = {"root":"_24c25a"};